<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="page-title">
          <div>Georgia Department of Transportation</div>
          <h1 class="mt-0">Georgia Crash Reporting Instructions</h1>
        </div>
      </div>
    </div>
    <div class="row mt-1">
      <div class="overview-text col">
        <div>
          <p>The Georgia Motor Vehicle Crash Report (GDOT-523) is the official document used in the collection and
            dissemination of crash data by Georgia’s law enforcement agencies. Throughout this guide users will note
            various
            data fields have been designated as Critical Data Items and have been identified with a symbol. Every effort
            should be made to ensure that accurate data is reported in these data fields. Additionally, for each data
            field,
            users will find information useful in coding fields that are often inconsistent.</p>

          <p>The report structure, fields, and attributes were developed in coordination with GDOT, Governor’s Office of
            Highway Safety (GOHS), Georgia Public Safety Training Center (GPSTC), Georgia Department of Public Safety
            (GDPS),
            Georgia Motor Carrier Compliance Division (GMCCD), and Georgia State Patrol (GSP) with the support of the
            Traffic
            Records Coordinating Committee Executive Board and Task Team.
          </p>
        </div>
        <MqResponsive landscape class="col-4" style="width: 30%;">
          <img class="crash-manual-logo"
            src="https://crashmanual.s3.us-east-2.amazonaws.com/SampleContent/crash_graphic.png"
            alt="Crash Safety Manual Logo" />
        </MqResponsive>
      </div>

      <h6>Produced in cooperation with the following agencies:</h6>
      <div class="partner-logo-container">
        <a href="https://www.dot.ga.gov/Pages/default.aspx" aria-label="GDOT" target="_blank">
           <img src="https://crashmanual.s3.us-east-2.amazonaws.com/agencies/gdot-logo.png"
          class="partner-logo" />
        </a>

        <a href="https://www.gahighwaysafety.org/" aria-label="Governor's Office of Highway Safety" target="_blank">
          <img src="https://crashmanual.s3.us-east-2.amazonaws.com/agencies/web_printLG_transparent_GOHS.png"
          class="partner-logo" />
        </a>

        <a href="https://www.gpstc.org/" aria-label="Georgia Public Safety Training Center" target="_blank">
          <img src="https://crashmanual.s3.us-east-2.amazonaws.com/agencies/GPSTC-Logo-1024x1024.png"
          class="partner-logo" />
        </a>

        <a href="https://dps.georgia.gov/" aria-label="Georgia Department of Public Safety" target="_blank">
          <img src="https://crashmanual.s3.us-east-2.amazonaws.com/agencies/GSP_logo.jpg" class="partner-logo" />
        </a>

        <a href="https://dps.georgia.gov/divisions/motor-carrier-compliance-division" aria-label="Georgia Motor Carrier Compliance Division" target="_blank">       
          <img src="https://crashmanual.s3.us-east-2.amazonaws.com/agencies/gsp-2017-motorcarrierpatch-cmyk-fullcolor.jpg"
            class="partner-logo" />
        </a>
       
        <a href="https://dps.georgia.gov/divisions/georgia-state-patrol" aria-label="Georgia State Patrol" target="_blank">       
          <img src="https://crashmanual.s3.us-east-2.amazonaws.com/agencies/GACP_logo.jpg" class="partner-logo" />
        </a>

      </div>

    </div>
    <div class="row pb-5">
      <div class="col">
        <!-- highlighted topics -->
        <h3 class="mt-3">Highlighted Topics</h3>
        <HighlightedTopics />
      </div>
    </div>
  </div>
</template>

<script>
import HighlightedTopics from '@/components/page_elements/HighlightedTopics.vue';
import GDOTLogo from "/public/gdot-logo.png"
import { MqResponsive } from "vue3-mq";


export default {
  name: "HomeView",
  components: {
    HighlightedTopics,
    MqResponsive
  },
  data() {
    return {
      GDOTLogo: GDOTLogo
    };
  },
};
</script>

<style scoped>
.page-title {
  width: 98%;
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, .25);
}

.crash-manual-logo {
  width: 100%;
  max-height: 300px;
  object-fit: contain;
}



.partner-logo-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 20px;
}



.partner-logo {
  max-height: 10rem;
  object-fit: contain;
}

.overview-text {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}

@media screen and (max-width: 768px) {
  .page-title {
    padding-top: 10px;
  }

  .partner-logo-container {
    justify-content: center !important;
    align-items: center !important;
    ;
  }

  .partner-logo {
    width: 40vw;
  }
}
</style>
